export const RESET = 'EXCMDEVICEPERIPHERAL_UPDATE_RESET'
export const SET_ERROR = 'EXCMDEVICEPERIPHERAL_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'EXCMDEVICEPERIPHERAL_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'EXCMDEVICEPERIPHERAL_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'EXCMDEVICEPERIPHERAL_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'EXCMDEVICEPERIPHERAL_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'EXCMDEVICEPERIPHERAL_UPDATE_UPDATE_RETRIEVED'
